import React, {useState, useEffect} from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import {PageWrapper} from "BaseComponents/Wrappers";
import {Search} from "Components/Search/";
import {useSelector, useDispatch} from "react-redux";

let SearchPage = ({searchModel, Heading, theme, ...rest}) => {
    const state = useSelector((state) => state.search);
    return (
        <PageWrapper theme={theme}>
            <Search Heading={Heading} {...searchModel} {...rest} />
        </PageWrapper>
    );
};

SearchPage.propTypes = {
    Heading: PropTypes.string,
};

export default SearchPage;
